export enum insProcessFireStep {
  /** 建築物資料 */
  InsureProcessBuildingInfo = 1,
  /** 選擇商品 */
  InsureProcessSelect = 2,
  /** 填寫資料 */
  InsureProcessFill = 3,
  /** 資料預覽 */
  InsureProcessPreview = 4,
  /** OTP 檢核頁 */
  InsureProcessVerifyOTP = 5,
  /** 確認付款 */
  InsureProcessPayment = 6,
  /** 成功投保 */
  InsureProcessSuccess = 7
}

export enum insProcessFireStepIcon {
  /** 建築物資料 icon */
  buildingIcon = 'building',
  /** 選擇商品 icon */
  selectIcon = 'select',
  /** 填寫資料 icon */
  fillIcon = 'fill',
  /** 資料預覽 icon */
  previewIcon = 'preview',
  /** 確認付款 icon */
  paymentIcon = 'payment',
  /** 成功投保 icon */
  successIcon = 'success'
}
